import React, { useState } from "react";
import "./Cart.css";
import { Fragment } from "react";
import ModalDialog from "../common/ModalDialog";
import useTokenCheck from "../../hooks/useTokenCheck";

const CartItem = ({ item, enableAction, onEditCartItem, onDeleteCartItem }) => {
  const [showDialog, setShowDialog] = useState(false);
  const { hasTokenExpired } = useTokenCheck();
  const handleDelete = async () => {
    await hasTokenExpired();
    setShowDialog(true);
  };

  const onClose = async () => {
    await hasTokenExpired();
    setShowDialog(false);
  };

  const onSubmit = async () => {
    await hasTokenExpired();
    setShowDialog(false);
    if (item) onDeleteCartItem({ orderItemId: item.itemId });
  };

  return (
    <Fragment>
      {showDialog && (
        <ModalDialog
          show={showDialog}
          onClose={onClose}
          onSubmit={onSubmit}
          title={"Confirmation"}
          message={"Are you sure you want to delete?"}
          cancelLabel={"No"}
          submitLabel={"Yes"}
        />
      )}
      <div className="cartItem">
        <div className="cartItem__lineBlock">
          <div className="cartItem__lineBlock__cardBlock">
            <div className="cartItem__lineBlock__cardBlock__icon">
              <i className="fas fa-money-check fa-3x"></i>{" "}
            </div>
            <div className="cartItem__lineBlock__cardBlock__infoBlock">
              <div>
                {item.description}{" "}
                {enableAction && (
                  <button
                    id="deleteCartItem"
                    name="deleteCartItem"
                    onClick={handleDelete}
                    className="cartItem__lineBlock__inlineActionButton"
                  >
                    Delete
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
        <div>${(item.price / 100).toFixed(2)}</div>
      </div>
    </Fragment>
  );
};

export default CartItem;
